export default __webpack_public_path__ + "static/media/study.60518e96.svg";